const config = {
	api: process.env.VUE_APP_API,
	stripeKey: process.env.VUE_APP_STRIPE,
	screenOrientation: ['landscape', 'portrait'],
	accountTypes: ['INDIVIDUAL', 'BUSINESS'],
	countriesEU : [ 'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LI', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'],
	defaultGridSize: 42,
	layouts: {
		landscape: [
			{
				id: 1,
				slots: [
					{
						w: 100,
						h: 100,
						x: 0,
						y: 0
					}
				]
			},
			{
				id: 2,
				slots: [
					{
						w: 50,
						h: 100,
						x: 0,
						y: 0
					},
					{
						w: 50,
						h: 100,
						x: 50,
						y: 0
					}
				]
			},
			{
				id: 3,
				slots: [
					{
						w: 33,
						h: 100,
						x: 0,
						y: 0
					},
					{
						w: 67,
						h: 100,
						x: 33,
						y: 0
					}
				]
			},
			{
				id: 4,
				slots: [
					{
						w: 67,
						h: 100,
						x: 0,
						y: 0
					},
					{
						w: 33,
						h: 100,
						x: 67,
						y: 0
					}
				]
			},
			{
				id: 5,
				slots: [
					{
						w: 33,
						h: 100,
						x: 0,
						y: 0
					},
					{
						w: 33,
						h: 100,
						x: 33,
						y: 0
					},
					{
						w: 33,
						h: 100,
						x: 66,
						y: 0
					}
				]
			},
			{
				id: 6,
				slots: [
					{
						w: 50,
						h: 50,
						x: 0,
						y: 0
					},
					{
						w: 50,
						h: 50,
						x: 50,
						y: 0
					},
					{
						w: 50,
						h: 50,
						x: 0,
						y: 50
					},
					{
						w: 50,
						h: 50,
						x: 50,
						y: 50
					}
				]
			},
			{
				id: 7,
				slots: [
					{
						w: 100,
						h: 85,
						x: 0,
						y: 0
					},
					{
						w: 100,
						h: 15,
						x: 0,
						y: 85
					}
				]
			},
			{
				id: 8,
				slots: [
					{
						w: 50,
						h: 85,
						x: 0,
						y: 0
					},
					{
						w: 50,
						h: 85,
						x: 50,
						y: 0
					},
					{
						w: 100,
						h: 15,
						x: 0,
						y: 85
					}
				]
			},
			{
				id: 9,
				slots: [
					{
						w: 100,
						h: 15,
						x: 0,
						y: 0
					},
					{
						w: 50,
						h: 85,
						x: 0,
						y: 15
					},
					{
						w: 50,
						h: 85,
						x: 50,
						y: 15
					}
				]
			},
			{
				id: 10,
				slots: [
					{
						w: 33,
						h: 85,
						x: 0,
						y: 0
					},
					{
						w: 33,
						h: 85,
						x: 33,
						y: 0
					},
					{
						w: 33,
						h: 85,
						x: 66,
						y: 0
					},
					{
						w: 100,
						h: 15,
						x: 0,
						y: 85
					}
				]
			},
			{
				id: 11,
				slots: [
					{
						w: 33,
						h: 50,
						x: 0,
						y: 0
					},
					{
						w: 33,
						h: 50,
						x: 33,
						y: 0
					},
					{
						w: 33,
						h: 50,
						x: 66,
						y: 0
					},
					{
						w: 33,
						h: 50,
						x: 0,
						y: 50
					},
					{
						w: 33,
						h: 50,
						x: 33,
						y: 50
					},
					{
						w: 33,
						h: 50,
						x: 66,
						y: 50
					}
				]
			},
			{
				id: 0,
				slots: []
			}
		],
		portrait: [
			{
				id: 1,
				slots: [
					{
						w: 100,
						h: 100,
						x: 0,
						y: 0
					}
				]
			},
			{
				id: 2,
				slots: [
					{
						w: 100,
						h: 50,
						x: 0,
						y: 0
					},
					{
						w: 100,
						h: 50,
						x: 0,
						y: 50
					}
				]
			},
			{
				id: 3,
				slots: [
					{
						w: 100,
						h: 33,
						x: 0,
						y: 0
					},
					{
						w: 100,
						h: 33,
						x: 0,
						y: 33
					},
					{
						w: 100,
						h: 33,
						x: 0,
						y: 66
					}
				]
			},
			{
				id: 4,
				slots: [
					{
						w: 50,
						h: 33,
						x: 0,
						y: 0
					},
					{
						w: 50,
						h: 33,
						x: 50,
						y: 0
					},
					{
						w: 50,
						h: 33,
						x: 0,
						y: 33
					},
					{
						w: 50,
						h: 33,
						x: 50,
						y: 33
					},
					{
						w: 50,
						h: 33,
						x: 0,
						y: 66
					},
					{
						w: 50,
						h: 33,
						x: 50,
						y: 66
					}
				]
			},
			{
				id: 5,
				slots: [
					{
						w: 50,
						h: 90,
						x: 0,
						y: 0
					},
					{
						w: 50,
						h: 90,
						x: 50,
						y: 0
					},
					{
						w: 100,
						h: 10,
						x: 0,
						y: 90
					}
				]
			},
			{
				id: 6,
				slots: [
					{
						w: 100,
						h: 10,
						x: 0,
						y: 0
					},
					{
						w: 50,
						h: 90,
						x: 0,
						y: 10
					},
					{
						w: 50,
						h: 90,
						x: 50,
						y: 10
					}
				]
			},
			{
				id: 7,
				slots: [
					{
						w: 100,
						h: 10,
						x: 0,
						y: 0
					},
					{
						w: 50,
						h: 40,
						x: 0,
						y: 10
					},
					{
						w: 50,
						h: 40,
						x: 50,
						y: 10
					},
					{
						w: 50,
						h: 40,
						x: 0,
						y: 50
					},
					{
						w: 50,
						h: 40,
						x: 50,
						y: 50
					},
					{
						w: 100,
						h: 10,
						x: 0,
						y: 90
					}
				]
			},
			{
				id: 0,
				slots: []
			}
		]
	},
	widgets: [
		{
			id: 'MEDIA',
			title: 'Media',
			version: 1,
			icon: 'media'
		},
		{
			id: 'WEBPAGE',
			title: 'Webpage',
			version: 1,
			icon: 'webpage'
		},
		{
			id: 'TEXT',
			title: 'Text',
			version: 1,
			icon: 'text'
		},
		{
			id: 'MARQUEE',
			title: 'Marquee',
			version: 1,
			icon: 'marquee'
		},
		{
			id: 'QRCODE',
			title: 'QR code',
			version: 1,
			icon: 'qrcode'
		},
		// {
		// 	id: 'DATE',
		// 	title: 'Date',
		// 	version: 1
		// },
		// {
		// 	id: 'WEATHER',
		// 	title: 'Weather',
		// 	version: 1
		// },
		// {
		// 	id: 'COUNTDOWN',
		// 	title: 'Countdown',
		// 	version: 1
		// },
		// {
		// 	id: 'YOUTUBE',
		// 	title: 'Youtube',
		// 	version: 1
		// },
		// {
		// 	id: 'GOOGLEMAPS',
		// 	title: 'Google maps',
		// 	version: 1
		// },
		// {
		// 	id: 'QUOTE',
		// 	title: 'Quote',
		// 	version: 1
		// }
	],
	paginationSize: {
		grid: 32,
		table: 10
	},
	resolutions: [
		'720x576',
		'720x1280',
		'768x1024',
		'800x600',
		'960x540',
		'1024x768',
		'1080x1920',
		'1080x2340',
		'1152x864',
		'1176x664',
		'1280x720',
		'1280x768',
		'1280x960',
		'1280x1024',
		'1280x1440',
		'1360x768',
		'1366x768',
		'1440x900',
		'1600x900',
		'1600x1024',
		'1600x1080',
		'1600x1200',
		'1920x165',
		'1920x360',
		'1920x540',
		'1920x1080',
		'1920x1200',
		'1920x1440',
		'2560x1080',
		'2560x1440',
		'2880x158',
		'3840x120',
		'3840x160',
		'3840x720',
		'3840x1080',
		'3840x2160'
	],
	deviceSizes: ['landscape', 'portrait', 'custom'],
	teamRoles: [
		{
			id: 'ADMIN',
			title: 'Administrator'
		},
		{
			id: 'EDITOR',
			title: 'Editor'
		},
		{
			id: 'VIEWER',
			title: 'Viewer'
		}
	]
}

export default config
